import { WahlbetrugEntry } from '../model/wahlbetrug';
import { DataFetcher } from './fetcher/DataFetcher';
import { createEqualCommand, RepositoryNocoDbBase } from './repositoryNocoDbBase.ts';

export interface WahlbetrugSearchParams extends AbstractSearchParams {
  country?: string;
  manipulation?: string;
  legal_outcome?: string;
  election_date?: string;
  date_from?: string;
  date_to?: string;
  title?: string;
}

export class WahlbetrugRepository extends RepositoryNocoDbBase<WahlbetrugEntry, WahlbetrugSearchParams> {
  protected readonly TABLE_NAME = 'wahlbetrug';

  protected readonly API_ROUTE = `${process.env.API_URL}v2/noco/tables/${this.TABLE_NAME}/records`;

  protected readonly META_ROUTE = `${process.env.API_URL}v2/meta/tables/${this.TABLE_NAME}`;

  protected readonly DATE_FIELD = 'election_date' as const;

  protected readonly RELEVANCE_FIELD = 'rating';

  protected readonly STATIC_FILTER = createEqualCommand('publish', 'true');

  protected readonly SELECT_FILTERS = ['country', 'manipulation', 'legal_outcome'];

  protected readonly EQUAL_FILTERS = ['country', 'legal_outcome'];

  protected readonly ANY_OF_FILTERS = ['manipulation'];

  protected readonly SEARCH_FIELDS: (keyof WahlbetrugEntry)[] = [
    'Title',
    'election',
    'region',
    'what_happened',
    'manipulation',
    'manipulation_other'
  ];

  public constructor(_fetcher: DataFetcher) {
    super(_fetcher);
  }
}
